<div class="overview-container wrapper">
  <div class="layout-wrapper">
    <!-- <hyperkit-tab-bar (tabSelect)="onTabSelect($event)" variant="primary" mode="underline">
    <hyperkit-tab [text]="tab.title" *ngFor="let tab of tabs; let i = index" [selected]="tab.selected">
      <router-outlet></router-outlet>
    </hyperkit-tab>
  </hyperkit-tab-bar> -->
    <kendo-tabstrip (tabSelect)="onTabSelect($event)">
      @for (tab of tabs; track tab; let i = $index) {
        <kendo-tabstrip-tab [title]="tab.title" [selected]="tab.selected">
          <ng-template kendoTabContent>
            <router-outlet></router-outlet>
          </ng-template>
        </kendo-tabstrip-tab>
      }
    </kendo-tabstrip>
  </div>
</div>
<div kendoDialogContainer></div>
